import { beforeEnterMicrofrontend } from '@/router/routes/business/inventory/utils/beforeEnterMicrofrontend'

export default [
  {
    path: ':path(products.*)?',
    name: 'inventory.products',
    beforeEnter: beforeEnterMicrofrontend('products'),
    component: () => import('@/views/business/inventory/products/iframe-service.vue'),
  },
]
